import { useCallback, useContext } from 'react';
import { DataRoomShareableLink } from 'models/ShareableLink';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import EditShareableLinkContext from 'router/subrouters/DataRoom/providers/EditShareableLink/EditShareableLink.context';

const useManageShareableLink = (link: DataRoomShareableLink) => {
  const { doesntHaveAccess } = useContext(DataRoomContext);
  const { openEditShareableLink } = useContext(EditShareableLinkContext);

  const manageShareableLink = useCallback(() => {
    if (doesntHaveAccess) return;

    openEditShareableLink(link);
  }, [doesntHaveAccess, openEditShareableLink, link]);

  return {
    manageShareableLink,
    isManageShareableLinkDisabled: doesntHaveAccess,
  };
};

export default useManageShareableLink;
